export const RESET_APPLICATION = 'reset';

export const STONKS_DID_CHANGE = 'stonksDidChange';

export const ERROR_DID_CHANGE = 'errorDidChange';

export const LOAD_PROGRESS_DID_CHANGE = 'loadProgressDidChange';

export const USER_DID_CHANGE = 'userDidChange';
